import React from "react";
import iconEnum from "@assets/icons";

export default ({ icon, onClick, className, custom, tabIndex }) => (
  <span {...{ onClick, className, tabIndex }}>
    {React.createElement(custom ? custom : iconEnum[icon])}
  </span>
);
